const state = {
    showButton: false,
    showDialog: false,
    loaded: false,
}

// Getters
const getters = {
    showButton: state => state.showButton,
    showDialog: state => state.showDialog,
    loaded: state => state.loaded,
    buttonText: state => (state.showDialog ? 'Fechar Chat' : 'Abrir Chat'),
}

const mutations = {
    onOff(state) {
        if (state.showButton) {
            mutations.finishChat(state)
        } else {
            mutations.initChat(state)
        }
    },
    initChat(state) {
        state.showButton = true
        state.showDialog = true
    },
    finishChat(state) {
        state.showButton = false
        state.showDialog = false
        state.loaded = false
    },
    switchDialogState(state) {
        state.showDialog = !state.showDialog
        if (!state.showDialog) {
            state.loaded = false
        }
    },
    switchLoadedState(state) {
        state.loaded = true
    },
    resetLoadedState(state) {
        state.loaded = false
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}
